import { redirect } from '@sveltejs/kit';
import { getLocaleFromUrl } from '@glimja/shared/utils';
import { localizeUrl, delocalizeUrl } from '$lib/parachute/routes';

/**
 * Checks if the current product URL uses the correct localized path and redirects if needed
 * This ensures users always access products through the proper localized URLs (e.g., /da/produkt/ instead of /da/product/)
 */
export const checkAndRedirectProductUrl = (url: URL): void => {
  const locale = getLocaleFromUrl(url);

  // Get the current pathname without query parameters
  const currentPathname = url.pathname;

  // Delocalize the current URL to get the raw pattern
  const delocalizedUrl = delocalizeUrl(url.href);
  const delocalizedUrlObj = new URL(delocalizedUrl);

  // Check if this is a product URL pattern
  if (delocalizedUrlObj.pathname.indexOf('/product/') !== 0) {
    return; // Not a product URL, no redirect needed
  }

  // Generate the correct localized URL for this locale
  const correctLocalizedUrl = localizeUrl(delocalizedUrl, locale.language);
  const correctUrl = new URL(correctLocalizedUrl);

  // Preserve search parameters from original URL
  correctUrl.search = url.search;

  // If the current path doesn't match the correct localized path, redirect
  if (currentPathname !== correctUrl.pathname) {
    redirect(301, correctUrl.pathname + correctUrl.search);
  }
};